import { forwardRef } from 'react';

import { Button } from '..';
import { TProps } from '../types/TProps';

export type TTabButtonProps = TProps & {
  $active: boolean;
};

export const LeftTabButton = forwardRef<HTMLButtonElement, TTabButtonProps>(({ $active, className, ...props }, ref) => (
  <Button
    ref={ref}
    className={['btn--tab-left', $active ? 'btn--tab-active' : 'btn--tab-inactive', className]
      .filter(Boolean)
      .join(' ')}
    {...props}
  />
));

LeftTabButton.displayName = 'LeftTabButton';

export const RightTabButton = forwardRef<HTMLButtonElement, TTabButtonProps>(
  ({ $active, className, ...props }, ref) => (
    <Button
      ref={ref}
      className={['btn--tab-right', $active ? 'btn--tab-active' : 'btn--tab-inactive', className]
        .filter(Boolean)
        .join(' ')}
      {...props}
    />
  ),
);

RightTabButton.displayName = 'RightTabButton';
